module.exports = __webpack_public_path__ + "media/images/minus-fc36554ff1a8702b7105c6eb9e886304.svg";